import { useSession } from "context/SessionContext";
import React, { useEffect, useState } from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";

interface RoutePropsData extends RouteProps {
  roles?: string[];
}

const PrivateRoute: React.FC<RoutePropsData> = ({ roles, ...rest }) => {
  const [hasPermission, setHasPermission] = useState(false);
  const { user } = useSession();

  useEffect(() => {
    const userRoles = user?.roles
      .map((role: { name: string }) => role.name)
      .join(", ");

    roles?.forEach((r) => {
      if (userRoles?.includes(r)) setHasPermission(true);
    });
  }, [user, roles]);

  if (!roles) return <Route {...rest} />;

  return hasPermission ? <Route {...rest} /> : <Redirect to="/" />;
};

export default PrivateRoute;
